import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbButtonModule,
  NbCardModule,
  NbProgressBarModule,
  NbTabsetModule,
  NbUserModule,
  NbIconModule,
  NbSelectModule,
  NbListModule,
} from '@nebular/theme';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TreeModule } from '@circlon/angular-tree-component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AutocompleteLibModule } from 'angular-ng-autocomplete'; 

import { ThemeModule } from '../../@theme/theme.module';
import { ChartModule } from 'angular2-chartjs';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { WorkComponent } from './work.component';
import { NotesComponent } from './notes/notes.component';
import { BriefComponent } from './brief/brief.component';
import { DetailComponent } from './detail/detail.component';
import { WorkRoutingModule } from './work-routing.module';
import { CheckInComponent } from './check-in/check-in.component';
import { ProceduresComponent } from './procedures/procedures.component';
import { EstimatesComponent } from './estimates/estimates.component';
import { NotesRecallComponent } from './notes-recall/notes-recall.component';
import { RecallComponent } from './recall/recall.component';
import { PetComponent } from './pet/pet.component';
import { ProfileComponent } from './profile/profile.component';
import { HistoryComponent } from './history/history.component';
import { ClientComponent } from './client/client.component';
import { ClientInfoComponent } from './client-info/client-info.component';
import { FamilyComponent } from './family/family.component';
import { FinancialComponent } from './financial/financial.component';
import { ContactsComponent } from './contacts/contacts.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { NotesHomeComponent } from './notes-home/notes-home.component';
import { ProfileMetabolicComponent } from './profile-metabolic/profile-metabolic.component';
import { ProfileEnvmentComponent } from './profile-envment/profile-envment.component';
import { ProfileVitalComponent } from './profile-vital/profile-vital.component';
import { ProfileDentalComponent } from './profile-dental/profile-dental.component';
import { PetInfoComponent } from './pet-info/pet-info.component';
import { PhysicalComponent } from './physical/physical.component';
import { AssociateComponent } from './associate/associate.component';
import { ApptReferredComponent } from './appt-referred/appt-referred.component';
import { ReferredComponent } from './referred/referred.component';
import { DataTablesModule } from 'angular-datatables';
import { SignaturePadModule } from 'angular2-signaturepad';

import { FinancialPipe } from '../../pipes/financial.pipe';
import { HistoryPipe } from '../../pipes/history.pipe';
import { SubHistoryPipe } from '../../pipes/subhistory.pipe';
import { PrescriptionPipe } from '../../pipes/prescription.pipe'; 
import { PaymentRegisterComponent } from './payment-register/payment-register.component';
import { TrimPipe } from '../../pipes/trim.pipe';
import { OrderHistoryPipe } from '../../pipes/order.pipe'; 
import { InvoicingModule } from './invoicing/invoicing.module';
import { FinancePetlvlComponent } from './finance-petlvl/finance-petlvl.component';
import { SetupStatsComponent } from './setup-stats/setup-stats.component';
import { SetupDoctornurseComponent } from './setup-doctornurse/setup-doctornurse.component';
import { InvModalComponent } from './invoicing/inv-modal/inv-modal.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ClientEmailComponent } from './client-email/client-email.component';
import { NoPetPageComponent } from './no-pet-page/no-pet-page.component';
import { FormatPhoneNumberPipe } from '../../pipes/formatPhoneNumber.pipe';
import { ClientNoteComponent } from './client-note/client-note.component';
import { PetNoteComponent } from './pet-note/pet-note.component';
import { ClientPersonComponent } from './client-person/client-person.component'; 
import { TreatmentPlanComponent } from './history/treatment-plan/treatment-plan.component'; 
import { DocumentComponent } from '../document/document.component';
import { TableModule } from 'primeng/table';
import { LabDataComponent } from './lab-data/lab-data.component'; 
import { NewlineToBrPipe } from '../../pipes/newlinetobr.pipe';
import { VitalSignComponent } from './vital-sign/vital-sign.component';
import { ProfileProcComponent } from './profile-proc/profile-proc.component';
import { SvgMapsComponent } from './profile-dental/svg-maps/svg-maps.component'; 
// import { PetRabieListComponent } from './pet-rabie-list/pet-rabie-list.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EstimatePageComponent } from './estimate-page/estimate-page.component';
import { LabCompareComponent } from './lab-compare/lab-compare.component';


// import { InvCasgregComponent } from './invoicing/inv-casgreg/inv-casgreg.component';
// import { InvReceiptComponent } from './inv-receipt/inv-receipt.component'; 

@NgModule({
  imports: [
    CommonModule,
    ThemeModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbIconModule,
    NbTabsetModule,
    NbSelectModule,
    NbListModule,
    ChartModule,
    NbProgressBarModule,
    NgxEchartsModule,
    NgxChartsModule,
    LeafletModule,
    WorkRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TreeModule,
    InfiniteScrollModule,
    AutocompleteLibModule,
    DataTablesModule,
    InvoicingModule,
    TableModule,
    SignaturePadModule,
    DragDropModule,
  ],
  declarations: [
    WorkComponent,
    DetailComponent,
    NotesComponent,
    BriefComponent,
    CheckInComponent,
    ProceduresComponent,
    EstimatesComponent,
    NotesRecallComponent,
    RecallComponent,
    ProfileComponent,
    PetComponent,
    HistoryComponent,
    ClientComponent,
    ClientInfoComponent,
    FamilyComponent,
    FinancialComponent,
    ContactsComponent,
    AppointmentsComponent,
    NotesHomeComponent,
    ProfileMetabolicComponent,
    ProfileEnvmentComponent,
    ProfileVitalComponent,
    ProfileDentalComponent,
    PetInfoComponent,
    PhysicalComponent,
    AssociateComponent,
    ApptReferredComponent,
    ReferredComponent,
    FinancialPipe,
    HistoryPipe,
    SubHistoryPipe,
    PrescriptionPipe,
    OrderHistoryPipe, 
    PaymentRegisterComponent,
    TrimPipe, 
    FinancePetlvlComponent,
    SetupStatsComponent,
    SetupDoctornurseComponent, 
    InvModalComponent, 
    LandingPageComponent,
    ClientEmailComponent,
    NoPetPageComponent,
    FormatPhoneNumberPipe,
    ClientNoteComponent,
    PetNoteComponent,
    ClientPersonComponent, 
    TreatmentPlanComponent,
    DocumentComponent,
    LabDataComponent,
    NewlineToBrPipe,
    VitalSignComponent,
    ProfileProcComponent,
    ProfileVitalComponent,
    SvgMapsComponent,
    EstimatePageComponent,
    LabCompareComponent,
    // PetRabieListComponent,
    // InvoicingComponent 
  ],
  providers: [
  ],
  exports: [
    AppointmentsComponent,
    ReferredComponent,
    FinancialComponent,
    ContactsComponent,
    NotesComponent,
    FamilyComponent,
    ClientInfoComponent, 
    SetupStatsComponent,
    SetupDoctornurseComponent,
    InvModalComponent,
    ClientEmailComponent,
    ClientPersonComponent, 
    DocumentComponent,
    LabDataComponent,
    LabCompareComponent,
    PetNoteComponent
  ]
})
export class WorkModule { }
